import { render, staticRenderFns } from "./RegistrationByPkwWithPlates.vue?vue&type=template&id=929a6500&"
import script from "./RegistrationByPkwWithPlates.vue?vue&type=script&lang=js&"
export * from "./RegistrationByPkwWithPlates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports